export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_31.db711a5b.jpg";